import React from "react";

//import "./index.css";

import GlobalValuesTableContainer from "./GlobalValuesTableContainer";
import { GlobalValuesContextProvider } from "../../../../contexts/global-values.context";

function GlobalValues(props) {
  return (
    <div className="deco-container">
      <GlobalValuesTableContainer />
    </div>
  );
}

export default GlobalValues;
